import {uploadFile, geocodeAddresses, pdfReportLocation, xlsxReportLocation, pdfReportCircle, xlsxReportCircle, removeAddresses} from "@/api/api.js"

export const customers = {
    state: {
        customers: [],
        customersLocation: {},
        customersPopup: false

    },
    getters: {
        getCustomers: state => state.customers,
        getCustomersLocation: state => state.customersLocation,
        getCustomersPopup: state => state.customersPopup
    },
    mutations: {
        SAVE_CUSTOMERS(state, payload) {
            state.customers = payload
        },
        SET_LOCATION(state, payload) {
            state.customersLocation = payload
        },
        SHOW_CUSTOMERS_POPUP(state, payload) {
            state.customersPopup = payload
        }
    },
    actions: {
        SET_LOCATION({commit}, payload) {
            commit('SET_LOCATION', payload)
        },
        SHOW_CUSTOMERS_POPUP({commit}, payload) {
            commit('SHOW_CUSTOMERS_POPUP', payload)
        },
        async uploadFile({commit, dispatch}, file) {
            dispatch('SHOW_CUSTOMERS_POPUP', false)
            commit('SAVE_CUSTOMERS', [])
            try {
                const response = await uploadFile(file)
                commit('SAVE_CUSTOMERS', response.data.data.items)
                dispatch('SHOW_CUSTOMERS_POPUP', true)
                return response;
            } catch(e) {
            }
        },
        async geocodeAddresses({state, dispatch}, data) {
            const location_id = state.customersLocation.id;
            const columns = data;
            const items = state.customers;
            try {
                const response = await geocodeAddresses({location_id, columns, items})
                if(response.data.data.addresses.length) {
                    dispatch('fetchAddresses')
                }
                dispatch('SHOW_CUSTOMERS_POPUP', false)
            } catch(e) {

            }
        },
        async removeAddresses({commit, dispatch}, id) {
            try {
                const response = await removeAddresses(id);
                if(response && response.status === 200) {
                    commit('REMOVE_ADDRESSES', id);
                    dispatch('UPDATE_ADDRESSES')
                }
            }catch(e) {
                console.log(e.response, 'response')
            }
        },
        async pdfReportLocation({state}) {
            const location_id = state.customersLocation.id;
            try {
                const response = await pdfReportLocation({location_id})
                return response;
            } catch(e) {
                console.log(e.response, 'error response')
            }
        },
        async xlsxReportLocation({state}) {
            const location_id = state.customersLocation.id;
            try {
                const response = await xlsxReportLocation({location_id})
                return response;
            } catch(e) {
                console.log(e.response, 'error response')
            }
        },
        async pdfReportCircle({state}, isCircleData) {
            try {
                const response = await pdfReportCircle(isCircleData);
                return response;
            } catch(e) {
                console.log(e.response, 'error response')
            }
        },
        async xlsxReportCircle({state}, isCircleData) {
            try {
                const response = await xlsxReportCircle(isCircleData);
                return response;
            } catch(e) {
                console.log(e.response, 'error response')
            }
        },
    }
}